// Win-check for all four objective types. Spec: docs/mechanics.md §5.
import { coordKey } from './hex.js';
import { listTiles } from './board.js';
export function checkWin(board, objective, movesUsed) {
    switch (objective.kind) {
        case 'clear': {
            if (board.tiles.size === 0)
                return 'won';
            return movesUsed >= objective.moveBudget ? 'lost' : 'ongoing';
        }
        case 'target': {
            const occ = new Map();
            for (const t of board.tiles.values())
                occ.set(coordKey(t.coord), t.color);
            const hit = objective.targets.every((req) => occ.get(coordKey(req.coord)) === req.color);
            if (hit)
                return 'won';
            return movesUsed >= objective.moveBudget ? 'lost' : 'ongoing';
        }
        case 'pattern': {
            if (matchesPatternAnywhere(board, objective.pattern))
                return 'won';
            return movesUsed >= objective.moveBudget ? 'lost' : 'ongoing';
        }
        case 'survival': {
            // Survival win-check is quota-based and handled by the survival runner, not here.
            // We expose 'ongoing' here; the runner tracks merges and flips to 'won'/'lost'.
            return 'ongoing';
        }
    }
}
// Returns true if any translation of the pattern matches the current tile positions+colors.
// Rotations are not applied here — authored patterns are position-free but rotation-fixed by spec.
function matchesPatternAnywhere(board, pattern) {
    if (pattern.length === 0)
        return true;
    // For each tile on the board, try anchoring pattern[0] there.
    const tiles = listTiles(board);
    for (const anchor of tiles) {
        if (anchor.color !== pattern[0].color)
            continue;
        const dq = anchor.coord.q - pattern[0].offset.q;
        const dr = anchor.coord.r - pattern[0].offset.r;
        let ok = true;
        for (const p of pattern) {
            const k = coordKey({ q: p.offset.q + dq, r: p.offset.r + dr });
            const tid = board.tileAt.get(k);
            if (tid === undefined) {
                ok = false;
                break;
            }
            const t = board.tiles.get(tid);
            if (t.color !== p.color) {
                ok = false;
                break;
            }
        }
        if (ok)
            return true;
    }
    return false;
}
